import { InnerBox } from "@/components/elements/InnerBox";
import { CustomerUserListTable } from "@/features/customer-user/components/CustomerUserListTable";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export const CustomerUserListPage: FC = () => {
  return (
    <Stack gap="24px">
      <Stack gap="4px">
        <Typography variant="head24Bold" color={text.primary}>
          ユーザー管理
        </Typography>
        <Typography variant="body14" color={text.secondary}>
          各プロダクトへアクセスできるユーザーを登録・停止などができます。
        </Typography>
      </Stack>
      <InnerBox padding="24px">
        <CustomerUserListTable />
      </InnerBox>
    </Stack>
  );
};
